exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._38ZtONOTmSp4ZlvpuIbCWr{overflow:auto;zoom:1;display:table;width:100%}._38ZtONOTmSp4ZlvpuIbCWr:after{content:\"\";display:block;clear:both}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/atoms/HashLink/style.css"],"names":[],"mappings":"AAAA,yBACI,cAAe,AACf,OAAQ,AACR,cAAe,AACf,UAAY,CACf,AAED,+BACI,WAAY,AACZ,cAAe,AACf,UAAY,CACf","file":"style.css","sourcesContent":[".box {\n    overflow: auto;\n    zoom: 1;\n    display: table;\n    width: 100%;\n}\n\n.box:after {\n    content: '';\n    display: block;\n    clear: both;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"box": "_38ZtONOTmSp4ZlvpuIbCWr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/atoms/HashLink/style.css
// module id = 953
// module chunks = 0 1 2 3